module.exports = __webpack_public_path__ + "img/cube.31a1f2ad.png";